"use client";

import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Info } from "lucide-react";
import { useState } from "react";

interface InfoPopoverProps {
  content: string;
}

const InfoPopover: React.FC<InfoPopoverProps> = ({ content }) => {
  const [open, setOpen] = useState(false);

  const handleClick = (e: React.MouseEvent) => {
    e.stopPropagation();       // Prevent selection of price option
    e.nativeEvent.stopImmediatePropagation(); // Ensure no bubbling
    setOpen(!open);
  };

  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button
          onClick={handleClick}
          onMouseDown={(e) => e.stopPropagation()} // Prevent mousedown from bubbling too
          className="ml-1 w-4 h-4 text-muted-foreground focus:outline-none"
        >
          <Info className="w-4 h-4" />
        </button>
      </PopoverTrigger>
      <PopoverContent
        side="top"
        align="center"
        className="text-xs p-2 rounded-md max-w-[200px] bg-white-1 shadow-md border border-gray-200"
      >
        {content}
      </PopoverContent>
    </Popover>
  );
};

export default InfoPopover;
